import React from "react";
import { dataFormatters } from "../../../../utils/dataFormatters";

function highlightSpeedAndDistance(value, speed_distanceValue) {
  if (value == speed_distanceValue) {
    return <span style={{ fontSize: "22px", fontWeight: "bold" }}>✔ {value}</span>;
  }
  return speed_distanceValue; // Return the original value if condition is not met
}

export const WorkersListSchema = {
  heights: { header1: "40px" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "",
      colSpan: 1,
      rowSpan: 1,
      topAlign: false,
      centerAlign: true,
      className: "tbl-text-normal",
      isValueOnly: true,
      accessor: "index",
    },
    {
      title: "",
      colSpan: 3,
      rowSpan: 1,
      topAlign: false,
      centerAlign: true,
      className: "tbl-text-normal",
      isValueOnly: true,
      accessor: "name",
    },
    {
      title: "",
      colSpan: 5,
      rowSpan: 1,
      topAlign: false,
      centerAlign: true,
      className: "tbl-text-normal",
      isValueOnly: true,
      Signature: true,
      accessor: "signature",
    },
    {
      title: "",
      colSpan: 3,
      rowSpan: 1,
      topAlign: false,
      centerAlign: true,
      className: "tbl-text-normal",
      isValueOnly: true,
      accessor: "companyName",
    },
  ],
};
export const WorkersListSchemaWithoutSignature = {
  heights: { header1: "40px" },
  classes: { header1: "" },
  inlineBodyData: true,
  columns: [
    {
      title: "",
      colSpan: 1,
      rowSpan: 1,
      topAlign: false,
      centerAlign: true,
      className: "tbl-text-normal",
      isValueOnly: true,
      accessor: "index",
    },
    {
      title: "",
      colSpan: 3,
      rowSpan: 1,
      topAlign: false,
      centerAlign: true,
      className: "tbl-text-normal",
      isValueOnly: true,
      accessor: "name",
    },
    {
      title: "",
      colSpan: 5,
      rowSpan: 1,
      topAlign: false,
      centerAlign: true,
      className: "tbl-text-normal",
      isValueOnly: true,
      accessor: "signature",
    },
    {
      title: "",
      colSpan: 3,
      rowSpan: 1,
      topAlign: false,
      centerAlign: true,
      className: "tbl-text-normal",
      isValueOnly: true,
      accessor: "companyName",
    },
  ],
};

export const HighBallJobSafetyReportSchema = [
  {
    heights: { header1: "60px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Job Briefing Report",
        colSpan: 12,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Date",
        colSpan: 3,
        rowSpan: 1,
        topAlign: false,
        leftAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: false,
        accessor: "date",
        formatter: (value) => {
          let date = dataFormatters.dateFormatterWithTimezone(value);
          return date;
        },
      },
      {
        title: "Location",
        colSpan: 9,
        rowSpan: 1,
        topAlign: false,
        leftAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: false,
        accessor: "loc",
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Supervisor",
        colSpan: 3,
        rowSpan: 1,
        topAlign: false,
        leftAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: false,
        accessor: "rwic",
      },
      {
        title: "EIC",
        colSpan: 9,
        rowSpan: 1,
        topAlign: false,
        leftAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: false,
        accessor: "p-rwic",
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Scope of work:",
        colSpan: 3,
        rowSpan: 1,
        topAlign: false,
        leftAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "",
        colSpan: 9,
        rowSpan: 1,
        topAlign: false,
        leftAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: false,
        isValueOnly: true,
        accessor: "tot",
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Safety rule:",
        colSpan: 3,
        rowSpan: 1,
        topAlign: false,
        leftAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "",
        colSpan: 9,
        rowSpan: 1,
        topAlign: false,
        leftAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: false,
        isValueOnly: true,
        accessor: "safety-rule",
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "",
        colSpan: 12,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Personnel Safety Check List",
        colSpan: 12,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
    ],
  },

  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "basic_ppe",
        formatter: (value) => {
          if (value) return <span style={{ fontSize: "20px", fontWeight: "bold" }}>✔ </span>;
        },
      },
      {
        title: "Basic PPE",
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "",
        colSpan: 9,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "basic_ppe_text",
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "wspecppe",
        formatter: (value) => {
          if (value) return <span style={{ fontSize: "20px", fontWeight: "bold" }}>✔ </span>;
        },
      },
      {
        title: "Work specific PPE",
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "",
        colSpan: 9,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "wspecppe_text",
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Emergency & first aid",
        colSpan: 3,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "",
        colSpan: 9,
        rowSpan: 1,
        topAlign: false,
        leftAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: false,
        isValueOnly: true,
        accessor: "emergency_first_aid_inst",
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Vehicle Safety Inspection",
        colSpan: 6,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "Track Equipment Safety Inspection",
        colSpan: 6,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "track_equipment_safety_inspection2",
        formatter: (value) => {
          if (value) return <span style={{ fontSize: "20px", fontWeight: "bold" }}>✔ </span>;
        },
      },
      {
        title: "Inspect vehicles that transports people & equipment",
        colSpan: 5,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
        unBold: true,
      },
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "track_equipment_safety_inspection3",
        formatter: (value) => {
          if (value) return <span style={{ fontSize: "20px", fontWeight: "bold" }}>✔ </span>;
        },
      },
      {
        title: "Inspect before each shift",
        colSpan: 5,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
        unBold: true,
      },
    ],
  },

  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Tool Safety Inspection",
        colSpan: 12,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
    ],
  },

  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "hand_tools",
        formatter: (value) => {
          if (value) return <span style={{ fontSize: "20px", fontWeight: "bold" }}>✔ </span>;
        },
      },
      {
        title: "Hand tools",
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "All hand tools used inspected",
        colSpan: 9,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
        unBold: true,
      },
    ],
  },

  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "",
        colSpan: 1,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "power_tools",
        formatter: (value) => {
          if (value) return <span style={{ fontSize: "20px", fontWeight: "bold" }}>✔ </span>;
        },
      },
      {
        title: "Power tools",
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "All power tools used inspected",
        colSpan: 9,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
        unBold: true,
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "",
        colSpan: 12,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "On Track Protection & Safety Being Used",
        colSpan: 12,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "No. of workers being supervised",
        colSpan: 12,
        rowSpan: 1,
        topAlign: false,
        leftAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: false,
        accessor: "num_workers_being_supervised",
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "RR contact person",
        colSpan: 6,
        rowSpan: 1,
        topAlign: false,
        leftAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: false,
        accessor: "rr_contact_person",
      },
      {
        title: "Phone/Radio#",
        colSpan: 6,
        rowSpan: 1,
        topAlign: false,
        leftAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: false,
        accessor: "phone_radio",
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Flag/Watchman",
        colSpan: 6,
        rowSpan: 1,
        topAlign: false,
        leftAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: false,
        accessor: "flag_watchman",
      },
      {
        title: "Sight distance",
        colSpan: 6,
        rowSpan: 1,
        topAlign: false,
        leftAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: false,
        accessor: "shift_distance",
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Permit/Track warrant#",
        colSpan: 6,
        rowSpan: 1,
        topAlign: false,
        leftAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: false,
        accessor: "permit_track_warrant",
      },
      {
        title: "Maximum train speed",
        colSpan: 6,
        rowSpan: 1,
        topAlign: false,
        leftAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: false,
        accessor: "maximum_train_speed",
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Type of track",
        colSpan: 6,
        rowSpan: 1,
        topAlign: false,
        leftAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: false,
        accessor: "type_of_track",
      },
      {
        title: "Designated place of safety",
        colSpan: 6,
        rowSpan: 1,
        topAlign: false,
        leftAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: false,
        accessor: "designated_place_of_safety",
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Exclusive track occupancy",
        colSpan: 4,
        rowSpan: 1,
        topAlign: false,
        leftAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: false,
        accessor: "exclusive_track_occupancy",
      },
      {
        title: "Foul time",
        colSpan: 4,
        rowSpan: 1,
        topAlign: false,
        leftAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: false,
        accessor: "foul_time",
      },
      {
        title: "Train coordination",
        colSpan: 4,
        rowSpan: 1,
        topAlign: false,
        leftAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: false,
        accessor: "train_co_ordination",
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Inaccessible track",
        colSpan: 4,
        rowSpan: 1,
        topAlign: false,
        leftAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: false,
        accessor: "inaccessible_track",
      },
      {
        title: "Train approach warning",
        colSpan: 4,
        rowSpan: 1,
        topAlign: false,
        leftAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: false,
        accessor: "train_approach_warning",
      },
      {
        title: "Work limits",
        colSpan: 4,
        rowSpan: 1,
        topAlign: false,
        leftAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: false,
        accessor: "work_limits",
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "",
        colSpan: 12,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Track that protection is granted on ",
        colSpan: 12,
        rowSpan: 1,
        topAlign: false,
        leftAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: false,
        accessor: ["track_protection_granted_on", "open2"],
        dontJoinValues: true,
        formatter: ([value1, value2]) => {
          if (!value1) return;
          if (value1 === "Name of Track") return value2;
          return value1;
        },
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Protection location",
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "From",
        colSpan: 4,
        rowSpan: 1,
        topAlign: false,
        leftAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: false,
        accessor: "protection_location_from",
      },
      {
        title: "To",
        colSpan: 6,
        rowSpan: 1,
        topAlign: false,
        leftAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: false,
        accessor: "protection_location_to",
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Protection time",
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "From",
        colSpan: 4,
        rowSpan: 1,
        topAlign: false,
        leftAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: false,
        accessor: "protection_time_from",
      },
      {
        title: "To",
        colSpan: 6,
        rowSpan: 1,
        topAlign: false,
        leftAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: false,
        accessor: "protection_time_to",
      },
    ],
  },

  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Dispatcher initials and OK'D time",
        colSpan: 12,
        rowSpan: 1,
        topAlign: false,
        leftAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: false,
        accessor: "disp_initials_ok_time",
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "",
        colSpan: 12,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Track that protection is granted on ",
        colSpan: 12,
        rowSpan: 1,
        topAlign: false,
        leftAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: false,
        accessor: ["track_protection_granted_on_2", "open3"],
        dontJoinValues: true,
        formatter: ([value1, value2]) => {
          if (!value1) return;
          if (value1 === "Name of Track") return value2;
          return value1;
        },
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Protection location",
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "From",
        colSpan: 4,
        rowSpan: 1,
        topAlign: false,
        leftAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: false,
        accessor: "protection_location_from_2",
      },
      {
        title: "To",
        colSpan: 6,
        rowSpan: 1,
        topAlign: false,
        leftAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: false,
        accessor: "protection_location_to_2",
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Protection time",
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "From",
        colSpan: 4,
        rowSpan: 1,
        topAlign: false,
        leftAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: false,
        accessor: "protection_time_from_2",
      },
      {
        title: "To",
        colSpan: 6,
        rowSpan: 1,
        topAlign: false,
        leftAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: false,
        accessor: "protection_time_to_2",
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Dispatcher initials and OK'D time",
        colSpan: 12,
        rowSpan: 1,
        topAlign: false,
        leftAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: false,
        accessor: "disp_initials_ok_time_2",
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "",
        colSpan: 12,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Additional notes and safety concerns",
        colSpan: 3,
        rowSpan: 1,
        topAlign: false,
        leftAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "",
        colSpan: 9,
        rowSpan: 1,
        topAlign: false,
        leftAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: false,
        isValueOnly: true,
        accessor: "additional_notes_safety_concerns",
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Speed in M.P hour",
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "Clearance distance in feet",
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "Speed in M.P hour",
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "Clearance distance in feet",
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "Speed in M.P hour",
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "Clearance distance in feet",
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "",
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "speed_in_mp_hour",
        formatter: (value) => highlightSpeedAndDistance(value, 5),
      },
      {
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "clearance_distance_in_feet_1",
        formatter: (value) => highlightSpeedAndDistance(value, 110),
      },
      {
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "speed_in_mp_hour",
        formatter: (value) => highlightSpeedAndDistance(value, 35),
      },
      {
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "clearance_distance_in_feet_1",
        formatter: (value) => highlightSpeedAndDistance(value, 770),
      },
      {
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "speed_in_mp_hour",
        formatter: (value) => highlightSpeedAndDistance(value, 65),
      },
      {
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "clearance_distance_in_feet_1",
        formatter: (value) => highlightSpeedAndDistance(value, 1430),
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "speed_in_mp_hour",
        formatter: (value) => highlightSpeedAndDistance(value, 10),
      },
      {
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "clearance_distance_in_feet_1",
        formatter: (value) => highlightSpeedAndDistance(value, 220),
      },
      {
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "speed_in_mp_hour",
        formatter: (value) => highlightSpeedAndDistance(value, 40),
      },
      {
        title: "880",
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "clearance_distance_in_feet_1",
        formatter: (value) => highlightSpeedAndDistance(value, 880),
      },
      {
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "speed_in_mp_hour",
        formatter: (value) => highlightSpeedAndDistance(value, 70),
      },
      {
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "clearance_distance_in_feet_1",
        formatter: (value) => highlightSpeedAndDistance(value, 1540),
      },
    ],
  },

  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "speed_in_mp_hour",
        formatter: (value) => highlightSpeedAndDistance(value, 15),
      },
      {
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "clearance_distance_in_feet_1",
        formatter: (value) => highlightSpeedAndDistance(value, 330),
      },
      {
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "speed_in_mp_hour",
        formatter: (value) => highlightSpeedAndDistance(value, 45),
      },
      {
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "clearance_distance_in_feet_1",
        formatter: (value) => highlightSpeedAndDistance(value, 990),
      },
      {
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "speed_in_mp_hour",
        formatter: (value) => highlightSpeedAndDistance(value, 75),
      },
      {
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "clearance_distance_in_feet_1",
        formatter: (value) => highlightSpeedAndDistance(value, 1650),
      },
    ],
  },

  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "speed_in_mp_hour",
        formatter: (value) => highlightSpeedAndDistance(value, 20),
      },
      {
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "clearance_distance_in_feet_1",
        formatter: (value) => highlightSpeedAndDistance(value, 440),
      },
      {
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "speed_in_mp_hour",
        formatter: (value) => highlightSpeedAndDistance(value, 50),
      },
      {
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "clearance_distance_in_feet_1",
        formatter: (value) => highlightSpeedAndDistance(value, 1100),
      },
      {
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "speed_in_mp_hour",
        formatter: (value) => highlightSpeedAndDistance(value, 80),
      },
      {
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "clearance_distance_in_feet_1",
        formatter: (value) => highlightSpeedAndDistance(value, 1760),
      },
    ],
  },

  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "speed_in_mp_hour",
        formatter: (value) => highlightSpeedAndDistance(value, 25),
      },
      {
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "clearance_distance_in_feet_1",
        formatter: (value) => highlightSpeedAndDistance(value, 550),
      },
      {
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "speed_in_mp_hour",
        formatter: (value) => highlightSpeedAndDistance(value, 55),
      },
      {
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",

        isValueOnly: true,
        accessor: "clearance_distance_in_feet_1",
        formatter: (value) => highlightSpeedAndDistance(value, 1210),
      },
      {
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "speed_in_mp_hour",
        formatter: (value) => highlightSpeedAndDistance(value, 85),
      },
      {
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "clearance_distance_in_feet_1",
        formatter: (value) => highlightSpeedAndDistance(value, 1870),
      },
    ],
  },

  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "speed_in_mp_hour",
        formatter: (value) => highlightSpeedAndDistance(value, 30),
      },
      {
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "clearance_distance_in_feet_1",
        formatter: (value) => highlightSpeedAndDistance(value, 660),
      },
      {
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "speed_in_mp_hour",
        formatter: (value) => highlightSpeedAndDistance(value, 60),
      },
      {
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "clearance_distance_in_feet_1",
        formatter: (value) => highlightSpeedAndDistance(value, 1320),
      },
      {
        title: "90",
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "speed_in_mp_hour",
        formatter: (value) => highlightSpeedAndDistance(value, 90),
      },
      {
        title: "1,980",
        colSpan: 2,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isValueOnly: true,
        accessor: "clearance_distance_in_feet_1",
        formatter: (value) => highlightSpeedAndDistance(value, 1980),
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Personnel at this work location",
        colSpan: 12,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "#",
        colSpan: 1,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "Print name",
        colSpan: 3,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "Signature",
        colSpan: 5,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "Company name",
        colSpan: 3,
        rowSpan: 1,
        topAlign: false,
        centerAlign: true,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/components/jobBriefing/JobBrieifingReport/HighBallReport/HighBallJobBriefingReportSchema.js